import React, { useContext } from 'react';
import { BrandingContext } from 'src/branding/BrandingContextProvider';
import ContactServiceRequests from 'src/pages/Contact/ContactServiceRequests';
import ContactDocuments from 'src/pages/Contact/ContactDocuments';
import ContactProperties from 'src/pages/Contact/ContactProperties';
import ContactNotes from 'src/pages/Contact/ContactNotes';
import Tabs from 'src/components/Tabs';

interface ContactTabsProps {
  contact: any;
  counts: any;
  noteVisibleToHomeownerOccupantRealtor: boolean;
  reFetchContactCountsFromAPI: any;
}

// This isn't being used right now, but it doesn't have to be thrown out and can be used as part of the modern refactor down the track.
const ContactTabs = ({
  contact,
  counts,
  noteVisibleToHomeownerOccupantRealtor,
  reFetchContactCountsFromAPI,
}: ContactTabsProps) => {
  const branding: any = useContext(BrandingContext);

  const homeOwnerCheck: boolean =
    contact &&
    contact.roles &&
    contact.roles.length > 0 &&
    (contact.roles[0].role.name === 'Home Owner' ||
      contact.roles[0].role.name === 'Occupant');

  const tabItems: any = [
    {
      label: branding.branding.text.serviceRequest + 's',
      count: counts.serviceRequestsCount ? counts.serviceRequestsCount : '0',
      content: <ContactServiceRequests contact={contact} />,
    },
    {
      label: 'Manuals & Documents',
      count: counts.documentsCount ? counts.documentsCount : '0',
      content: <ContactDocuments contact={contact} />,
    },
    homeOwnerCheck
      ? {
          label: 'Properties',
          count: counts.propertiesCount ? counts.propertiesCount : '0',
          content: <ContactProperties contact={contact} />,
        }
      : {},
    (homeOwnerCheck || contact.roles[0].role.name === 'Realtor') &&
    noteVisibleToHomeownerOccupantRealtor === false
      ? {}
      : {
          label: 'Notes',
          count: counts.notesCount ? counts.notesCount : '0',
          content: (
            <ContactNotes
              contact={contact}
              reFetchContactCountsFromAPI={reFetchContactCountsFromAPI}
            />
          ),
        },
  ];

  return <Tabs from={'Contact'} activeTab={null} items={tabItems} />;
};

export default ContactTabs;
